// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1qj7P","notes":"Notes_notes__sUEFb"};